<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="退款对账单列表"
                name="1"
                link="/finance/activity/refund/reconciliation/list"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/fans/report/login/list')"
                label="异常对账处理"
                name="2"
                link="/finance/activity/refund/reconciliation/exception"
            ></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
    },
    data() {
        return {
            activeName: this.name,
        };
    },
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>